// extracted by mini-css-extract-plugin
module.exports = {"FeaturedTop":"FrontPage_FeaturedTop__1My1o","FeaturedBottom":"FrontPage_FeaturedBottom__3fHj_","FrontInfo":"FrontPage_FrontInfo__nqW0b"};